var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "is-showing-bandana": false,
        "is-showing-sitewide-modal": false,
      },
    },
    [
      _c("wa-page-header-limited", {
        key: "header",
        attrs: { slot: "header", title: "Thanks for Your Icon Commission" },
        slot: "header",
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "app-content padding-y-7xl",
          attrs: { slot: "content", role: "main" },
          slot: "content",
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _vm.currentProduct.sku === "CI-SINGLE"
                ? _c("commission-1-success", { attrs: { theme: _vm.theme } })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentProduct.sku === "CI-SIXPACK"
                ? _c("commission-6-success", { attrs: { theme: _vm.theme } })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentProduct.sku === "CI-CASE24"
                ? _c("commission-24-success", { attrs: { theme: _vm.theme } })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentProduct.sku === "CI-BRAND"
                ? _c("commission-logo-success", { attrs: { theme: _vm.theme } })
                : _vm._e(),
              _vm._v(" "),
              _c("hr", {
                staticClass: "margin-bottom-4xl",
                staticStyle: {
                  "--hr-border-color": "var(--white)",
                  "--hr-border-width": "var(--border-width-xs)",
                },
              }),
              _vm._v(" "),
              _c("success-footer", {
                attrs: { "is-new-account": _vm.isNewAccount, theme: _vm.theme },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("wa-page-footer-simple", {
        attrs: { slot: "footer" },
        slot: "footer",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }